import _ from 'lodash';
import { createSelector } from 'reselect';
import { getAgents } from './simple';

export function setup() {
  const func = createSelector(
    getAgents,
    (agents) => _.get(agents, '[0].id') !== 1,
  );
  return func;
}

export default setup();
